/**
 * @generated SignedSource<<83b9e380b521fa532140ab6601a1932e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModalContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WithWalletConnectionEnsured_viewer" | "ZipCodeFormContent_viewer">;
  readonly " $fragmentType": "NftPdpBidModalContent_viewer";
};
export type NftPdpBidModalContent_viewer$key = {
  readonly " $data"?: NftPdpBidModalContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModalContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WithWalletConnectionEnsured_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ZipCodeFormContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7f35f5a1e35a8ed3cdf584a181a09d89";

export default node;
